import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  kitId: string;
  version: number;
  name?: string;
  notes?: string;
};

const [useUpdateKitVersion, updateKitVersion] = createAsyncAction(
  "kitVersions/update",
  async (args: Args) => {
    const res = await API.call<{ kitVersion: string }>({
      endpoint: `kits/${args.kitId}`,
      method: "PUT",
      data: {
        version: args.version,
        version_identifier: args.name,
        notes: args.notes,
      },
    });
    return { ...res, result: res.result.kitVersion };
  }
);

export default useUpdateKitVersion;
export { updateKitVersion };
